// Packages
import { t } from 'i18next'
// Components
import BasicInfoIcon from '../components/icons/BasicInfoIcon'
import DashboardIcon from '../components/icons/DashboardIcon'
import DocumentPlusIcon from '../components/icons/DocumentPlusIcon'
import PlaningIcon from '../components/icons/PlaningIcon'
import PlusClipboardIcon from '../components/icons/PlusClipboardIcon'
import ReportIcon from '../components/icons/ReportIcon'
import UserIcon from '../components/icons/UserIcon'
import { UserRole } from '../types/generalType'
// Types
import { Menu } from './type/menu'

const sidebarMenu: Menu[] = [
  // Dashboard
  {
    key: 'dashboard',
    id: 'dashboard',
    path: '/',
    accessRole: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.ADMIN,
      UserRole.PILGRIM,
      UserRole.PROVICEBROKER,
      UserRole.BROKER,
    ],
    title: t('homePage'),
    Icon: DashboardIcon,
    hasSubMenu: false,
  },
  // Pre-Reserve
  {
    key: 'pre-reserve',
    id: 'pre-reserve',
    accessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    title: t('preReserves'),
    Icon: PlusClipboardIcon,
    hasSubMenu: true,
    subMenu: [
      {
        key: 'pre-reserve-view',
        id: 'pre-reserve-view',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
        path: '/PreReserve',
        title: t('viewPreReserve'),
      },
      {
        key: 'pre-reserve-transfer-date',
        id: 'pre-reserve-transfer-date',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.PROVICEBROKER],
        path: '/PreReserve/TransferDate',
        title: t('saveTransferDate'),
      },
    ],
  },
  // Pilgrim Search
  {
    key: 'pilgrim-search',
    id: 'pilgrim-search',
    path: '/PilgrimSearch',
    accessRole: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    title: t('pilgrimSearch'),
    Icon: UserIcon,
    hasSubMenu: false,
  },
  // Basic info
  {
    key: 'basic-info',
    id: 'basic-info',
    accessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    title: t('basicInfo'),
    Icon: BasicInfoIcon,
    hasSubMenu: true,
    subMenu: [
      {
        key: 'basic-info-subMenu-1',
        id: 'basic-info-subMenu-1',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
        path: '/BasicInfo/Province',
        title: t('province'),
      },
    ],
  },
  // Pilgrim Pre-Reserve
  {
    key: 'my-pre-reserve',
    id: 'my-pre-reserve',
    path: '/PreReserve/MyPreReserve',
    accessRole: [UserRole.PILGRIM],
    title: t('myPreReserve'),
    Icon: PlusClipboardIcon,
    hasSubMenu: false,
  },
  // New Pre-Reserve
  {
    key: 'new-pre-reserve',
    id: 'new-pre-reserve',
    path: 'PreReserve/ReserveNewPreReserve',
    accessRole: [UserRole.PILGRIM],
    title: t('newPreReserve'),
    Icon: DocumentPlusIcon,
    hasSubMenu: false,
  },
  // Planing
  {
    key: 'planing',
    id: 'planing',
    accessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    title: t('planing'),
    Icon: PlaningIcon,
    hasSubMenu: true,
    subMenu: [
      {
        key: 'planing-subMenu-1',
        id: 'planing-subMenu-1',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
        path: 'Proclamation',
        title: t('periods'),
      },
      {
        key: 'planing-subMenu-2',
        id: 'planing-subMenu-2',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
        path: 'SajayaInformationConfirm',
        title: t('SajayaInformationConfirmByFile'),
      },
    ],
  },
  // Reports
  {
    key: 'reports',
    id: 'reports',
    accessRole: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    title: t('reports'),
    Icon: ReportIcon,
    hasSubMenu: true,
    subMenu: [
      {
        key: 'reports-subMenu-1',
        id: 'reports-subMenu-1',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
        path: '/Report/PreReserveStatus',
        title: t('preReserveReportBaseOnStatus'),
      },
      {
        key: 'reports-subMenu-2',
        id: 'reports-subMenu-2',
        subAccessRole: [
          UserRole.AdMINISTRATOR,
          UserRole.AdminWatcher,
          UserRole.Accountant,
          UserRole.PROVICEBROKER,
        ],
        path: '/Report/PreReservePaidStat',
        title: t('preReservePaidStat'),
      },
      {
        key: 'reports-subMenu-3',
        id: 'reports-subMenu-3',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
        path: '/Report/PreReserveNotPaidStat',
        title: t('preReserveNotPaidStat'),
      },
      {
        key: 'reports-subMenu-4',
        id: 'reports-subMenu-4',
        subAccessRole: [
          UserRole.AdMINISTRATOR,
          UserRole.AdminWatcher,
          UserRole.Accountant,
          UserRole.PROVICEBROKER,
        ],
        path: '/Report/PreReserveCanceledStat',
        title: t('preReserveCanceledStat'),
      },
      {
        key: 'reports-subMenu-5',
        id: 'reports-subMenu-5',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
        path: '/Report/PreReserveStat',
        title: t('preReserveStat'),
      },
      {
        key: 'reports-subMenu-6',
        id: 'reports-subMenu-6',
        subAccessRole: [
          UserRole.AdMINISTRATOR,
          UserRole.AdminWatcher,
          UserRole.Accountant,
          UserRole.PROVICEBROKER,
        ],
        path: '/Report/Payment',
        title: t('payments'),
      },
      {
        key: 'reports-subMenu-7',
        id: 'reports-subMenu-7',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
        path: '/Report/SajayaRelationStat',
        title: t('sajayaStat'),
      },
      {
        key: 'reports-subMenu-8',
        id: 'reports-subMenu-8',
        subAccessRole: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
        path: '/Report/CitiesStat',
        title: t('citiesPreReserveStat'),
      },
    ],
  },
]

export default sidebarMenu
